import React from 'react'
import { useNavigate } from 'react-router-dom'
import { Typography, Link } from '@mui/material_modern'
import { makeStyles } from '@mui/styles'
import { ASSET_STATUS_ICONS_DICT } from 'components/containers/load-board/utils/constants'
import DataGridWithSearchV2 from 'components/generic/datagrid/DataGridWithSearchV2'

const useStyles = makeStyles(theme => ({
  root: {
    '& .MuiDataGrid-columnHeaderTitleContainer': {
      padding: theme.spacing(0),
    },
    '& .MuiDataGrid-columnHeaderTitle': {
      paddingLeft: theme.spacing(0.75),
      paddingRight: theme.spacing(0),
    },
    '& .MuiDataGrid-columnHeader:focus': {
      outline: 'none',
    },
    '& .MuiDataGrid-cell:focus': {
      outline: 'none',
    },
    '& .MuiDataGrid-row': {
      cursor: 'pointer',
    },
  },
}))

const columns = [
  {
    field: 'assetName',
    headerName: 'Truck Name',
    align: 'left',
    flex: 1,
  },
  {
    field: 'status',
    headerName: 'Status',
    flex: 1,
    renderCell: ({ row }) => {
      const { status, statusName } = row || {}
      return (
        <>
          {ASSET_STATUS_ICONS_DICT[status]}
          <Typography pl={1} variant="body2">
            {statusName}
          </Typography>
        </>
      )
    },
  },
  {
    field: 'type',
    headerName: 'Truck Type',
    flex: 1,
  },
  {
    field: 'plateState',
    headerName: 'Plate State',
    flex: 1,
  },
  {
    field: 'licensePlate',
    headerName: 'License Plate',
    flex: 1,
  },
  {
    field: 'location',
    headerName: 'Location',
    flex: 2,
  },
  {
    field: 'daysOnSite',
    headerName: 'Days On Site',
    flex: 1,
  },
  {
    field: 'totalRoutes',
    headerName: 'Total Routes',
    flex: 1,
  },
  {
    field: 'dispatchTicketId',
    headerName: 'Dispatch Ticket',
    flex: 1,
    renderCell: ({ row }) => {
      const { dispatchTicketId } = row || {}
      return (
        <Typography variant="body2">
          {dispatchTicketId ? (
            <Link
              href={`/app/load-board/ticket-history/${dispatchTicketId}`}
              onClick={event => {
                event.preventDefault()
                event.stopPropagation()
                window.open(`/app/load-board/ticket-history/${dispatchTicketId}`, '_blank')
              }}
            >
              Latest Dispatch Ticket
            </Link>
          ) : (
            '--'
          )}
        </Typography>
      )
    },
  },
]

const TruckAssetsGrid = props => {
  const classes = useStyles()
  const navigate = useNavigate()

  const handleRowClick = row => {
    navigate(`/app/assets/trucks/${row.id}/profile`)
  }

  return (
    <DataGridWithSearchV2
      {...props}
      className={classes.root}
      columns={columns}
      textSearchPlaceholder="Search for anything"
      onRowClick={handleRowClick}
      autoPageSize={false}
    />
  )
}

TruckAssetsGrid.propTypes = DataGridWithSearchV2.propTypes

TruckAssetsGrid.defaultProps = DataGridWithSearchV2.defaultProps

export default TruckAssetsGrid
